"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPosterImageUrl = exports.getImageUrl = exports.ImageSize = void 0;
var ImageSize;
(function (ImageSize) {
    ImageSize["Small"] = "small";
    ImageSize["Medium"] = "medium";
    ImageSize["Original"] = "original";
})(ImageSize = exports.ImageSize || (exports.ImageSize = {}));
const getImageUrl = (posterImageUrl, size = ImageSize.Original) => {
    if (!posterImageUrl)
        return '';
    // Backward compatibility - if it's a string, return it
    if (typeof posterImageUrl === 'string') {
        return posterImageUrl;
    }
    // New object structure - return requested size
    return posterImageUrl[size] || posterImageUrl.original || '';
};
exports.getImageUrl = getImageUrl;
// Helper function for direct usage safety
const getPosterImageUrl = (posterImageUrl) => {
    return (0, exports.getImageUrl)(posterImageUrl, ImageSize.Original);
};
exports.getPosterImageUrl = getPosterImageUrl;
//# sourceMappingURL=ImageUtil.js.map